"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeitungMath = void 0;
/**
 * Namespace for all functions related to Zugentlastungen calculations.
 */
class LeitungMath {
    /**
     * Calculates the missing cable overlap for leitungen of espool
     * documentation for espool leitung length
     * https://igusdev.atlassian.net/wiki/spaces/EKE10/pages/3843227685/e-spool#Regeln-zu-Leitungen
     */
    static calcMissingLeitungUeberstandForEspool(espoolLeitungLengthMin_mm, leitungslaenge_mm, ueberstand_mm, extraLeitungLength_mm, strainReliefCount) {
        const extraLeitungPart_mm = LeitungMath.calculateExtraLengthForLeitungOfEspool(strainReliefCount, extraLeitungLength_mm);
        return leitungslaenge_mm - espoolLeitungLengthMin_mm - ueberstand_mm - extraLeitungPart_mm;
    }
    /**
     * Calculates the cable length for espool
     * documentation for espool leitung length
     * https://igusdev.atlassian.net/wiki/spaces/EKE10/pages/3843227685/e-spool#Regeln-zu-Leitungen
     */
    static calcLeitungLengthforEspoolByUerberstaende(espoolLeitungLengthMin_mm, ueberstandFestpunkt_mm, ueberstandMitnehmer_mm, extraLeitungLength_mm, strainReliefCount) {
        const extraLeitungPart_mm = LeitungMath.calculateExtraLengthForLeitungOfEspool(strainReliefCount, extraLeitungLength_mm);
        return espoolLeitungLengthMin_mm + extraLeitungPart_mm + ueberstandFestpunkt_mm + ueberstandMitnehmer_mm;
    }
    /**
     * Calculates extra length of Leitung for e-spools.
     * documentation for espool leitung length
     * https://igusdev.atlassian.net/wiki/spaces/EKE10/pages/3843227685/e-spool#Regeln-zu-Leitungen
     *
     * The extraLength_mm calculated by the count of used StrainRelief(strainReliefCount) + 1 and multiply by extraLeitungLength_mm
     *
     * Base calculation is:
     *  extraLength_mm = (strainReliefCount + 1) * extraLeitungLength_mm
     */
    static calculateExtraLengthForLeitungOfEspool(strainReliefCount, extraLeitungLengthPerStrainRelief_mm) {
        return (strainReliefCount + 1) * extraLeitungLengthPerStrainRelief_mm;
    }
}
exports.LeitungMath = LeitungMath;
//# sourceMappingURL=leitung.js.map